function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}
import qs from 'qs';
import api from "../../../utils/api";
import { RequestParams } from "../../../utils/RequestParams";



















const lookup = async (
{
  entityTitle,
  template,
  limit = 10




},
headers) =>
{
  try {
    const search = {
      fields: ['title', 'sharedId', 'template'],
      filter: _objectSpread(_objectSpread({},
      entityTitle && { searchString: `title:${entityTitle}~2` }),
      template && { template }),

      page: { limit }
    };

    const requestParams = new RequestParams(qs.stringify(search), headers);

    if (headers && headers['Content-Language']) {
      api.locale(headers['Content-Language']);
    }

    const response = await api.get('v2/search', requestParams);
    return { rows: response.json.data, count: response.json.data.length };
  } catch (e) {
    return e;
  }
};

export { lookup };